import { AbstractControl, ValidatorFn } from "@angular/forms";

const emailPatternRegEx = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export default class CustomValidators {
  static emailPattern = '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$';

  static match(controlName: string, matchControlName: string, ignoreCase: boolean = false): ValidatorFn {
    return (controls: AbstractControl) => {
      const control = controls.get(controlName);
      const matchControl = controls.get(matchControlName);
      
      let controlValue = control?.value;
      let matchValue = matchControl?.value;

      if (ignoreCase && typeof controlValue === 'string' && typeof matchValue === 'string') {
        controlValue = controlValue.toLowerCase();
        matchValue = matchValue.toLowerCase();
      }

      if (!matchControl?.errors && controlValue !== matchValue) {
        matchControl?.setErrors({
          matchingError: {
            actualValue: matchControl?.value,
            requiredValue: control?.value
          }
        })
        return { matchingError: true };
      } else if (controlValue === matchValue) {
        matchControl.setErrors(null);
      }
      return null
    }
  }
}

export function emailWithTextAppendedValidator(appendedText: string): ValidatorFn {
  
  return (control: AbstractControl) => {
    if (!control.value) {
      return null;
    }
    let modifiedEmail = control.value.toLowerCase();

     //checking if email has '@usda.gov' already appended
    if (!modifiedEmail.includes(appendedText)){
      modifiedEmail = control.value.concat(appendedText);
    }

    const isValidEmail = emailPatternRegEx.test(modifiedEmail);
      return isValidEmail ? null : { 'usda_email_address' : true, 'pattern' : true };
  }

}